"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _userCanViewStats = _interopRequireDefault(require("../../../schema/security/user-can-view-stats"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../../schema/security/user-is-system-admin"));
var _link = _interopRequireDefault(require("../../core/link"));
var _navTabs = _interopRequireDefault(require("../../core/nav-tabs"));
var _statsSummary = _interopRequireDefault(require("./stats-summary"));
var _entryStatus = _interopRequireDefault(require("./entry-status"));
var _entrySource = _interopRequireDefault(require("./entry-source"));
var _placeAvailability = _interopRequireDefault(require("./place-availability"));
var _financeSummary = _interopRequireDefault(require("./finance-summary"));
var _entriesByDivisions = _interopRequireDefault(require("./entries-by-divisions"));
var _notFound = _interopRequireDefault(require("../../not-found"));
var _fullWidth = _interopRequireDefault(require("../../root/full-width"));
var _requireAuthentication = _interopRequireDefault(require("../../require-authentication"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref2 = /*#__PURE__*/_react.default.createElement("h1", null, "Statistics");
var _ref3 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Statistics({
  isAuthenticated,
  user,
  match: {
    url,
    path
  }
}) {
  if (!isAuthenticated || !(0, _userCanViewStats.default)(user)) return _ref;
  return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, /*#__PURE__*/_react.default.createElement("div", null, _ref2, /*#__PURE__*/_react.default.createElement(_navTabs.default, null, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url + '/summary'
  }, "Summary"), /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url + '/entry-status'
  }, "Entries By Status"), /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url + '/entry-source'
  }, "Entry Source Comparisons"), /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url + '/place-availability'
  }, "Place Availability"), /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url + '/entries-by-divisions'
  }, "Entries By Division"), !(0, _userIsSystemAdmin.default)(user) ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    exact: true,
    to: url + '/finance-summary'
  }, "Finance Summary")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: path,
    to: url + '/summary'
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/summary',
    component: _statsSummary.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/entry-status',
    component: _entryStatus.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/place-availability',
    component: _placeAvailability.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/entries-by-divisions',
    component: _entriesByDivisions.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/entry-source',
    component: _entrySource.default
  }), !(0, _userIsSystemAdmin.default)(user) ? null : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/finance-summary',
    component: _financeSummary.default
  }), _ref3))));
}
var _default = exports.default = (0, _requireAuthentication.default)(Statistics);